import { APIRequest } from '@/app/services/APIRequest';
import store from '@/app/vuex/store';
import { formatCurrency, numberWithComma } from '@/app/helpers/FormatCurrency';
import Navbar from '@/views/components/layouts/Navbar.vue';

export default {
  components: {
    Navbar
  },
  data: () => ({
    headers: [
      { text: 'รหัสสินค้า', align: 'center', value: 'code' },
      { text: 'ชื่อสินค้า', align: 'center', value: 'name' },
      { text: 'ต้นทุน', align: 'right', value: 'cost' },
      { text: 'ราคาขาย', align: 'right', value: 'price' },
      { text: 'จำนวนสินค้า', align: 'right', value: 'qty' },
      { text: '', align: 'center', value: 'action' }
    ],
    itemsTableData: []
  }),
  mounted(){
    this.getTableData();
  },
  methods: {
    formatCurrency,
    numberWithComma,
    getTableData(){
      store.dispatch('loading/setLoading', true);
      APIRequest({
        method: 'POST',
        url: '/product/list-by-query',
        auth: true
      }).then(response => {
        if (response && response.data.code === 10){
          this.itemsTableData = response.data.result;
        }
        store.dispatch('loading/setLoading', false);
      }).catch(error => {
        console.log(error);
        store.dispatch('loading/setLoading', false);
      });
    }
  }
};
